var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "slide-fade" } }, [
    _vm.isOpen
      ? _c("div", { staticClass: "genplan-popup" }, [
          _c("div", { staticClass: "genplan-popup__wrapper" }, [
            _c(
              "div",
              { staticClass: "genplan__canvas" },
              [
                _c(
                  "svg",
                  {
                    staticClass: "genplan__canvas-svg",
                    attrs: {
                      viewBox: [
                        `0 0 ${_vm.renderSize.width} ${_vm.renderSize.height}`,
                      ],
                      preserveAspectRatio:
                        "xMidYMid\n                         slice",
                    },
                  },
                  [
                    _c("image", {
                      attrs: {
                        x: "0",
                        y: "0",
                        width: "100%",
                        height: "100%",
                        "xlink:href": _vm.render.link,
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      staticClass: "genplan__canvas-overlay",
                      attrs: {
                        width: "100%",
                        height: "100%",
                        "fill-opacity": "0.6",
                        mask: "url(#visual-canvas__hole)",
                      },
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.render.elements, function (element) {
                      return _c("path", {
                        key: element.id,
                        class: [
                          "genplan__canvas-path",
                          { "is-active": _vm.selected.includes(+element.id) },
                        ],
                        attrs: { id: "1", link: element.link, d: element.path },
                        on: {
                          click: function ($event) {
                            _vm.selected.includes(+element.id)
                              ? _vm.selected.splice(
                                  _vm.selected.indexOf(+element.id),
                                  1
                                )
                              : _vm.selected.push(+element.id)
                          },
                        },
                      })
                    }),
                    _vm._v(" "),
                    _c("defs", [
                      _c(
                        "mask",
                        { attrs: { id: "visual-canvas__hole" } },
                        [
                          _c("rect", {
                            attrs: {
                              fill: "white",
                              width: "100%",
                              height: "100%",
                            },
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.render.elements, function (element) {
                            return _c("path", {
                              key: element.id,
                              attrs: { d: element.path },
                            })
                          }),
                        ],
                        2
                      ),
                    ]),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "genplan__canvas-close",
                    on: { click: _vm.closeOpen },
                  },
                  [_c("ButtonClose")],
                  1
                ),
                _vm._v(" "),
                _c("transition", { attrs: { name: "slide-fade" } }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "button button_theme_color genplan__canvas-button button_theme_content-width",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.selectBuilding()
                        },
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.submitButton))])]
                  ),
                ]),
              ],
              1
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }